/**
 * Created by rouven on 21.06.17.
 */
import React from 'react';
import Symbol from '@wikom/react-symbol';
import Layout from '../layout/Layout';
var AccessDenied = function () { return (React.createElement(Layout, null,
    React.createElement("div", { className: "alert alert-danger alert--sysnotice" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-2 text-center" },
                React.createElement(Symbol, { symbol: "ban" })),
            React.createElement("div", { className: "col-md-10" },
                React.createElement("h2", null, "Zugriff verweigert"),
                React.createElement("p", null, "Sie haben nicht die erforderliche Berechtigung zum Anzeigen dieser Seite.")))))); };
export default AccessDenied;
